/* eslint-disable jsx-a11y/no-noninteractive-element-interactions */
/* eslint-disable import/no-unresolved */
import { Button, IconButton, Drawer, List, ListItem, Grid } from '@mui/material';
import { useLocation, useNavigate } from 'react-router';
import { useState, useEffect } from 'react';
import { useFetchGraphQL } from '../../hooks';
import GET_HEADAR from '../../query/header';
import { ReactComponent as HamburgerIcon } from '../../assets/svg/hamburger.svg';
import { ReactComponent as CloseIcon } from '../../assets/svg/close-white.svg';

function Header({ onClick }) {
  const location = useLocation();
  const navigate = useNavigate();
  const [drawerOpen, setDrawerOpen] = useState(false);
  const { loading, error, data } = useFetchGraphQL(GET_HEADAR);
  const { headerLogo = {}, navigationLinks = [], headerButtons = [] } = data?.header || {};

  const handleNavigation = (url) => {
    navigate(url);
    setDrawerOpen(false);
  };

  const toggleDrawer = () => {
    setDrawerOpen(!drawerOpen);
  };

  // Handle button clicks - either trigger the hero menu or the provided onClick
  const handleButtonClick = (button) => {
    // Check if the button is for login/signup
    if (button.label === 'Login' || button.label === 'Sign Up') {
      // If it's a login/signup button, trigger the hero menu functionality
      if (onClick) onClick(button.label.toLowerCase().replace(' ', '-'));
      navigate('/');
    } else if (onClick) {
      // For other buttons, use the default onClick behavior
      onClick();
    }
  };

  // Prevent body scrolling when drawer is open
  useEffect(() => {
    if (drawerOpen) {
      document.body.style.overflow = 'hidden';
    } else {
      document.body.style.overflow = 'auto';
    }

    return () => {
      document.body.style.overflow = 'auto';
    };
  }, [drawerOpen]);

  if (loading) return <p>Loading...</p>;
  if (error) return <p>Error! {error.message}</p>;

  return (
    <header style={{
      position: 'fixed',
      top: 0,
      left: 0,
      right: 0,
      zIndex: 1000,
      width: '100%',
    }}>
      {/* Desktop Header */}
      <Grid container sx={{ display: { xs: 'none', md: 'block' } }}>
        <div className="header-wrap">
          <div className="brand-logo">
            <img
              src={`${headerLogo?.image?.url}`}
              alt={headerLogo?.label}
              onClick={() => handleNavigation(headerLogo?.url)} />
          </div>
          <div className="navigation-link-wrap">
            {navigationLinks?.map((i) => (
              <div
                key={i.id}
                className="navigation-link"
                onClick={() => handleNavigation(i?.url)}
              >
                {i?.title}
                {location.pathname === i?.url ? <span className="link-active" /> : null}
              </div>
            ))}
          </div>
          <div className="header-buttons-wrap">
            {headerButtons?.map((i) => (
              <Button
                key={i?.id}
                size="large"
                sx={{ '&:focus': { border: '1px solid #ffffff' } }}
                variant={i?.variant}
                onClick={() => handleButtonClick(i)}
              >
                {i?.label?.slice(0, 25)}
              </Button>
            ))}
          </div>
        </div>
      </Grid>

      {/* Mobile Header */}
      <Grid container sx={{ display: { xs: 'flex', md: 'none' }, padding: '12px 20px', background: '#01161e', alignItems: 'center', justifyContent: 'space-between', width: '100vw' }}>
        <div className="brand-logo" style={{ width: 'auto' }}>
          <img
            src={`${headerLogo?.image?.url}`}
            alt={headerLogo?.label}
            style={{ maxHeight: '20px' }}
            onClick={() => handleNavigation(headerLogo?.url)} />
        </div>
        <IconButton
          edge="end"
          color="inherit"
          aria-label="menu"
          onClick={toggleDrawer}
          sx={{ color: '#ffffff' }}
        >
          {/* <img src={hamburger} alt="hamburger" /> */}
          <HamburgerIcon />
        </IconButton>
      </Grid>

      {/* Mobile Drawer */}
      <Drawer
        anchor="right"
        open={drawerOpen}
        onClose={toggleDrawer}
        PaperProps={{
          sx: {
            width: '100%',
            background: '#01161e',
            color: '#ffffff',
            padding: '20px 0px',
          },
        }}
      >
        <div style={{ display: 'flex', justifyContent: 'flex-end', paddingRight: '20px' }}>
          <IconButton
            onClick={toggleDrawer}
            sx={{ color: '#ffffff', fontSize: '30px' }}
          >
            <CloseIcon />
          </IconButton>
        </div>
        <List>
          {navigationLinks?.map((item) => (
            <ListItem
              key={item?.id}
              onClick={() => handleNavigation(item?.url)}
              sx={{
                padding: '15px 20px',
                cursor: 'pointer',
                position: 'relative',
                fontFamily: 'Lato',
                fontSize: '18px',
                '&:hover': { backgroundColor: 'rgba(255,255,255,0.05)' },
              }}
            >
              <div className="mobile-nav-link">
                {item?.title}
              </div>
            </ListItem>
          ))}
          <div style={{ marginTop: '20px', padding: '0px 20px' }}>
            {headerButtons?.map((button) => (
              <Button
                key={button?.id}
                fullWidth
                size="large"
                variant={button?.variant}
                onClick={() => handleButtonClick(button)}
                sx={{
                  marginBottom: '10px',
                  '&.MuiButton-outlined': {
                    borderColor: '#ffffff',
                    color: '#ffffff',
                  },
                }}
              >
                {button?.label?.slice(0, 25)}
              </Button>
            ))}
          </div>
        </List>
      </Drawer>
    </header>
  );
}

export default Header;
